import { Capacitor } from '@capacitor/core';

/**
 * App flavor — set via VITE_APP_FLAVOR at build time.
 *
 * 'traveler' → the native Sekretly app (iOS/Android). One app for everyone:
 *              travelers and hosts both use it and switch role in the profile
 *              menu (see nativeRoles in useAuth). It never offers admin.
 * undefined  → the web app, which keeps every role including admin.
 *
 * A native app is never the web/admin app. If one was built without a flavor
 * (e.g. via plain `npm run build` + `cap sync`), it still counts as the native
 * app, so a phone never gets the admin role.
 */
export type AppFlavor = 'traveler' | undefined;

export const APP_FLAVOR: AppFlavor = (() => {
  const v = import.meta.env.VITE_APP_FLAVOR as string | undefined;
  if (v === 'traveler') return v;
  if (Capacitor.isNativePlatform()) return 'traveler';
  return undefined;
})();

/** True in the native app: no admin role, native-only behaviour. */
export const IS_FLAVORED = APP_FLAVOR !== undefined;

/**
 * Build-time stamp, e.g. "sekretly-build-flavor:traveler". The release
 * workflows look for it in dist/ to prove VITE_APP_FLAVOR reached the build
 * (the native fallback above would otherwise hide a mis-built app).
 */
export const BUILD_FLAVOR_STAMP = `sekretly-build-flavor:${(import.meta.env.VITE_APP_FLAVOR as string | undefined) ?? 'none'}`;
